import "normalize.css";

import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { initializeIcons } from "@fluentui/react/lib/Icons";

import { App } from "./Components/App";
import { AuthenticationProvider } from "./Components/Generic/Authentication";
import { ConfigurationProvider } from "./Components/Generic/Configuration";
import { TranslationProvider } from "./Components/Generic/Translator";
import { Store } from "./Store";

async function start() {
  try {
    initializeIcons();

    ReactDOM.render(
      <StrictMode>
        <Provider store={Store}>
          <ConfigurationProvider>
            <TranslationProvider>
              <AuthenticationProvider>
                <App />
              </AuthenticationProvider>
            </TranslationProvider>
          </ConfigurationProvider>
        </Provider>
      </StrictMode>,
      document.getElementById(`app`)
    );
  } catch (e) {
    console.error(e.stack);
  }
}

start();
